const sceneEvents = new Phaser.Events.EventEmitter();

const EVENT_GAME_INITED = Symbol('EVENT_GAME_INITED');
const EVENT_GAME_START = Symbol('EVENT_GAME_START');
const EVENT_GAME_LEVELUP = Symbol('EVENT_GAME_LEVELUP');
const EVENT_GAME_OVER = Symbol('EVENT_GAME_OVER');
const EVENT_GAME_UPDATESCORE = Symbol('EVENT_GAME_UPDATESCORE');
const EVENT_PACMAN_HASPOWER = Symbol('EVENT_PACMAN_HASPOWER');
const EVENT_PACMAN_LOSEPOWER = Symbol('EVENT_PACMAN_LOSEPOWER');
const EVENT_PACMAN_LOSELIFE = Symbol('EVENT_PACMAN_LOSELIFE');
const EVENT_PACMAN_GAINLIFE = Symbol('EVENT_PACMAN_GAINLIFE');

export {
    sceneEvents,
    EVENT_GAME_INITED,
    EVENT_GAME_START,
    EVENT_PACMAN_HASPOWER,
    EVENT_PACMAN_LOSEPOWER,
    EVENT_PACMAN_LOSELIFE,
    EVENT_PACMAN_GAINLIFE,
    EVENT_GAME_LEVELUP,
    EVENT_GAME_OVER,
    EVENT_GAME_UPDATESCORE
};